import { render, staticRenderFns } from "./ObjectElementViewingDialog.vue?vue&type=template&id=8601b4f8&scoped=true&"
import script from "./ObjectElementViewingDialog.vue?vue&type=script&lang=js&"
export * from "./ObjectElementViewingDialog.vue?vue&type=script&lang=js&"
import style0 from "./ObjectElementViewingDialog.vue?vue&type=style&index=0&id=8601b4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8601b4f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
